import Daorut from "./daorut/Daorut";
import Spa from "./Spa/Spa";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Giadung from "./Giadung/Giadung";
import Gdprivacy from "./Giadung/Gdprivacy";


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Daorut />} />
          <Route path="/online" element={<Daorut />} />
          <Route path="/uu-dai" element={<Daorut />} />
          <Route path="/quy-trinh" element={<Daorut />} />
          <Route path="/giadung" element={<Giadung />} />
          <Route path="/privacy" element={<Gdprivacy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
